import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 0 }

import jsSHA from 'jssha/dist/sha1';
import { ref, onMounted } from 'vue';
import { getFromStorage, setToStorage } from '@/js/lib/helper/expirable-local-storage';

const TTL = 86400;

export default /*@__PURE__*/_defineComponent({
  __name: 'header-banner',
  props: {
    title: {},
    subtitle: { default: '' },
    color: {},
    backgroundColor: {},
    href: {},
    isSale: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const styleObj = {
  '--background-color': props.backgroundColor,
  '--color': props.color,
} as Record<string, string>;
const isShow = ref(true);
const key = ref('');
const genKey = () => {
  const sha1 = new jsSHA('SHA-1', 'TEXT');
  sha1.update(props.href);
  key.value = `close-campaign-banner-${sha1.getHash('HEX')}`;
};
const onClick = () => {
  isShow.value = false;
  setToStorage({ key: key.value, value: true, expirationSeconds: TTL });
};

onMounted(() => {
  genKey();
  isShow.value = !getFromStorage({ key: key.value });
});

return (_ctx: any,_cache: any) => {
  return (isShow.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_ctx.$style.banner, _ctx.color === '#fff' && _ctx.$style.bold]),
        style: styleObj
      }, [
        _createElementVNode("a", { href: _ctx.href }, [
          (_ctx.isSale)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.$style.sale)
                }, "SALE", 2)
              ]))
            : _createCommentVNode("", true),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
            (_ctx.subtitle)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.subtitle), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.showMore)
          }, "詳細はこちら", 2)
        ], 8, _hoisted_1),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(_ctx.$style.close),
          "aria-label": "キャンペーンバナーを閉じる",
          onClick: onClick
        }, null, 2)
      ], 2))
    : _createCommentVNode("", true)
}
}

})